import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ProfileService extends GenericService {
  constructor() {
    super('/profiles', axiosInstance);
  }
}

export default new ProfileService(); 